import React from 'react';
import PropTypes from 'prop-types';
import appUserRoutes from "appUserRoutes";
import {Col, Row} from "reactstrap";
import apiPlatform from "../../../apiPlatform";
import WarehouseProductThresholdCountIcon from "./WarehouseProductThresholdCountIcon";
import PriceFormatted from "../../Application/PriceFormatted";
import {PRICE_TYPE_NET} from "../../../utils/price";
import getWorkshop from "../../../utils/getWorkshop";
import WarehouseProductSellPrice from "./WarehouseProductSellPrice";
import {toast} from "react-toastify";
import {CopyToClipboard} from "react-copy-to-clipboard";
import workerHasPrivilege from "../../../utils/workerHasPrivilege";
import getWorkshopSetting from "../../../utils/getWorkshopSetting";
import apiUser from "../../../apiUser";
import Files from "../../Files/Files";
import {useTranslation} from "react-i18next";
import ObjectLinkWithDetails from "../../../componentsReusable/ObjectLinkWithDetails";
import WarehouseDocumentItemTable from "./WarehouseProductLabel/WarehouseDocumentItemTable";

const WarehouseProductLabel = ({productId, name, disableRedirect, textTruncateAutoWidth}) => {
  const { t } = useTranslation('warehouse_product_link')
  const [warehouseProductData, setWarehouseProductData] = React.useState();

  const getDetailsBody = () => {
    return <>
      <Row className="text-nowrap">
        <Col xs={12} md={6}>
          <span className="text-secondary">{t('popover.code')}: </span>
          <span className="ml-1">
            <CopyToClipboard
              text={warehouseProductData.product.code}
              onCopy={() => toast.success(t('popover.code_copied_msg'))}
            >
              <span className="ml-1 cursor-pointer">{warehouseProductData.product.code}</span>
            </CopyToClipboard>
          </span>
        </Col>
        {(getWorkshopSetting('product.quantityControlEnabled') && workerHasPrivilege('products.quantities')) && <Col xs={12} md={6}>
          <span className="text-secondary">{t('popover.warehouse_quantity')}: </span>
          <span className="ml-1">
            <WarehouseProductThresholdCountIcon warehouseProduct={warehouseProductData}/>
            <span className="ml-1 ">{warehouseProductData.available} / {warehouseProductData.count}</span>
          </span>
        </Col>}
        {getWorkshopSetting('product.quantityControlEnabled') && <Col xs={12} md={6}>
          <span className="text-secondary">{t('popover.last_income')}: </span>
          <span className="ml-1">{warehouseProductData.lastIncomeDate ??
            <i className="text-secondary">{t('popover.last_income_empty')}</i>}</span>
        </Col>}
        {workerHasPrivilege('products.priceVisible') && <Col xs={12} md={6}>
          <span className="text-secondary">{t('popover.buy_sell_value')}: </span>
          <span className="ml-1">
            <PriceFormatted value={getWorkshop().settingShowPrice === PRICE_TYPE_NET ? warehouseProductData.product.priceNet : warehouseProductData.product.priceGross}/>
            <span> / </span>
            <WarehouseProductSellPrice showPrice={getWorkshop().settingShowPrice} product={warehouseProductData.product}/>
          </span>
        </Col>}
      </Row>
      <Files
        id={warehouseProductData.product.id}
        classNameWrapper="mt-2"
        fetchFilesFn={apiUser.products.getFiles}
        disableLoader
      />
      <WarehouseDocumentItemTable productId={productId}/>
    </>
  }

  return <ObjectLinkWithDetails
    icon="fas fa-dolly-flatbed"
    link={appUserRoutes.products.product(productId)}
    linkText={name}
    disableRedirect={disableRedirect}
    textTruncateAutoWidth={textTruncateAutoWidth}
    objectData={warehouseProductData ? {
      title: name,
      body: () => getDetailsBody(),
    } : null}
    getObjectData={() => apiPlatform.warehouseProducts.list('product=' + productId).then(({data}) => setWarehouseProductData(data['hydra:member'][0]))}
  />
};

WarehouseProductLabel.defaultProps = {
  disableRedirect: false,
  textTruncateAutoWidth: true,
};

WarehouseProductLabel.propTypes = {
  textTruncateAutoWidth: PropTypes.bool,
  productId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  disableRedirect: PropTypes.bool,
};

export default WarehouseProductLabel;
